declare var BUILD_ENVIRONMENT: "staging" | "production" | undefined
declare var COMMIT_HASH: string | undefined
declare var BUILD_CONFIG:
	| {
		env?: "development" | "staging" | "production"
		doorhub_host?: string
		version_hash?: string
		dev_doorhub_token?: string
	}
	| undefined

import { IBuildConfiguration } from "./types"
import packageJson from "../../../package.json"

let BuildConfiguration: IBuildConfiguration
const devConfig: Partial<IBuildConfiguration> = {}

if (__DEV__) {
	BuildConfiguration = {
		ENV: "development",
		VERSION_NAME: packageJson.version,
		VERSION_CODE: packageJson.versionCode,
		APPLICATION_ID: "monitoimikaappi-web",
		DOORHUB_HOST: "https://doorhub.dev.pusatec.fi",
		...devConfig,
	}
} else if (typeof BUILD_CONFIG !== "undefined" && BUILD_CONFIG) {
	console.info("Found runtime build configuration", BUILD_CONFIG)

	BuildConfiguration = {
		ENV: BUILD_CONFIG.env ?? "development",
		VERSION_NAME: packageJson.version,
		VERSION_CODE: packageJson.versionCode,
		VERSION_HASH: BUILD_CONFIG.version_hash,
		APPLICATION_ID: "monitoimikaappi-web",
		DOORHUB_HOST: BUILD_CONFIG.doorhub_host ?? "http://127.0.0.1:9976",
		DEV_DOORHUB_TOKEN: BUILD_CONFIG.dev_doorhub_token,
	}
} else if (typeof BUILD_ENVIRONMENT !== "undefined" && BUILD_ENVIRONMENT) {
	console.info("Found build configuration", BUILD_ENVIRONMENT)

	BuildConfiguration = {
		ENV: BUILD_ENVIRONMENT,
		VERSION_NAME: packageJson.version,
		VERSION_CODE: packageJson.versionCode,
		VERSION_HASH: COMMIT_HASH,
		APPLICATION_ID: "monitoimikaappi-web",
		DOORHUB_HOST: BUILD_ENVIRONMENT === "production"
			? "https://doorhub.pusatec.fi"
			: "https://doorhub.dev.pusatec.fi",
	}
} else {
	console.error("Invalid environment configuration")
	throw Error("Invalid environment configuration")
}

console.info("Using build configuration", BuildConfiguration)

export { BuildConfiguration }
